import { render, staticRenderFns } from "./ModalCreateStats.vue?vue&type=template&id=2436f32a&scoped=true"
import script from "./ModalCreateStats.vue?vue&type=script&lang=js"
export * from "./ModalCreateStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436f32a",
  null
  
)

export default component.exports